import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3139DetailLotsHandler } from "./U3139DetailLotsHandlers";

interface U3139DetailLotsDeleteDlgProps {
  handler: U3139DetailLotsHandler;
  t: TFunction;
  NS: string;
}

function U3139DetailLotsDeleteDlg({ handler, t, NS }: U3139DetailLotsDeleteDlgProps) {
  if (!handler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={handler.isDeleteDialogOpen} onClose={handler.onDlgDeleteClose} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteDetailLotConfirmation", {
          count: handler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handler.gridStateHandlers.getSelectedRows().map((row, index, array) => (
          <span key={row.id ?? (row as any)._tempId} className="inline-block text-gray-800">
            {row.initialLot ?? "—"}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3139DetailLotsDeleteDlg;
